"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Theme = void 0;
/**
 * The Vanilla theme types.
 */
let Theme = exports.Theme = /*#__PURE__*/function (Theme) {
  Theme["DARK"] = "dark";
  Theme["LIGHT"] = "light";
  return Theme;
}({});